var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loaded)?_c('div',[(_vm.vipInfo)?_c('IsVip',{attrs:{"userInfo":_vm.userInfo,"vipInfo":_vm.vipInfo}}):_c('UpdataApp')],1):_c('AppLoading',{staticClass:"loading"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }